import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import { copy } from 'ember-copy';
import ApiService from 'cio/services/api';
import Transition from '@ember/routing/-private/transition';
import { redirectIfMasqingReadOnly } from 'cio/utils/route-access';
import ConfirmChangesService from 'cio/services/confirm-changes';

export default class EditRoute extends Route {
  @service api!: ApiService;
  @service confirmChanges!: ConfirmChangesService;

  crumb() {
    return {
      name: 'Edit',
      path: 'actions.url_params.edit',
    };
  }

  async beforeModel(transition: Transition) {
    await super.beforeModel(transition);

    return redirectIfMasqingReadOnly(this, transition);
  }

  model() {
    return this.api.request('url_params');
  }

  setupController(
    controller: any, // controller not typed yet
    model: { url_params: { name: string; nameError?: string | null; value: string; valueError?: string | null }[] },
  ) {
    let modelParams = model.url_params;

    // If there are no parameters, instantiate an empty one to be populated
    if (modelParams.length === 0) {
      modelParams.pushObject({ name: '', value: '' });
    }

    modelParams.forEach((param) => {
      param.nameError = null;
      param.valueError = null;
    });

    controller.set('urlParams', copy(modelParams, true));
    controller.set('originalParams', copy(modelParams, true));
    this.confirmChanges.register(controller, this);
  }
}
